<template>
  <div class="product-item">
    <bg-intro :bg="bg" class="bg-wrapper">
      <div class="video-intro">
        <h2>北斗SDK</h2>
        <p>
          开发者通过集成磐钴智能提供的北斗SDK即可实现常用的北斗短报文收发等常规操作，大大节约开发者的研发时间，目前SDK覆盖安卓手机、苹果手机、北斗短报文一体机、安卓平板电脑、PC电脑各端。
        </p>
        <div class="btn-wrapper">
          <!-- <div class="btn-content space-between">
            <img src="../../assets/product/play.svg" alt="play" />
            <span>点击视频了解</span>
          </div> -->
        </div>
      </div>
    </bg-intro>
    <highlight :highlightsData="highlightData"></highlight>
    <product title="产品应用形态"></product>

    <div class="area">
      <h3>应用领域</h3>
      <div class="area-wrapper content_wrapper space-between">
        <div class="area-item">
          <img src="../../assets/product/lingyu1.webp" alt="领域1" />
          <p>应急通信</p>
        </div>
        <div class="area-item">
          <img src="../../assets/product/lingyu2.webp" alt="领域2" />
          <p>野外救援</p>
        </div>
        <div class="area-item">
          <img src="../../assets/product/lingyu3.webp" alt="领域3" />
          <p>武警安防</p>
        </div>
        <div class="area-item">
          <img src="../../assets/product/lingyu4.webp" alt="领域4" />
          <p>森林防火</p>
        </div>
      </div>
    </div>

    <beDevelop></beDevelop>
  </div>
</template>

<script>
import bgIntro from '@/components/common/product/bgIntro.vue';
import highlight from '@/components/common/solution/highlight.vue';
import product from '@/components/common/solution/product.vue';
import beDevelop from '@/components/common/beDevelop.vue';
export default {
  metaInfo: {
    title: '北斗SDK应用-支持安卓+苹果+PC端',
    meta: [
      {
        name: 'keywords',
        content: '北斗短报文sdk,北斗APP开发,北斗短报文应用api,北斗二次开发',
      },
      {
        name: 'description',
        content:
          '成熟北斗应用：支持RDSS短报文通信和RNSS定位产品，支持北斗二号4.0和2.1协议，支持北斗三号协议。适用多类硬件：覆盖安卓手机、苹果手机、北斗短报文一体机、安卓平板电脑、PC电脑各端。',
      },
    ],
  },
  data() {
    return {
      bg: require('../../assets/product/SDKbanner.webp'),
      bgIntroData: {
        bgSrc: require('../../assets/solution/yydj-banner.webp'),
        title: '一站式OEM专属定制',
        intro: '提供一站式智能设备IOS、Android开发服务',
      },

      highlightData: {
        title: '服务优势',
        items: [
          {
            id: 'h1',
            title: '成熟北斗应用',
            intro: '支持RDSS短报文通信和RNSS定位产品，支持北斗二号4.0和2.1协议，支持北斗三号协议',
            imgSrc: require('../../assets/product/youshi1.webp'),
            color: '#EFA65E',
          },
          {
            id: 'h2',
            title: '适用多类硬件',
            intro: '覆盖安卓手机、苹果手机、北斗短报文一体机、安卓平板电脑、PC电脑各端',
            imgSrc: require('../../assets/product/youshi2.webp'),
            color: '#63B59F',
          },
          {
            id: 'h3',
            title: '一直在进步，持续更新迭代',
            intro: '产品稳定更新，持续迭代，紧跟北斗发展动态',
            imgSrc: require('../../assets/product/youshi3.webp'),
            color: '#4173FB',
          },
        ],
      },
    };
  },

  components: {
    bgIntro,
    highlight,
    product,
    beDevelop,
  },
};
</script>

<style lang="scss" scoped>
.product-item {
  width: 100%;
  .area {
    padding: 70px 0px;
    h3 {
      text-align: center;
      margin-bottom: 60px;
    }
    .area-wrapper {
      .area-item {
        p {
          text-align: center;
          margin-top: 15px;
          font-size: 16px;
          font-weight: 400;
          color: #333333;
          line-height: 30px;
        }
      }
    }
  }
}
</style>